import { zzjg } from '@/api/index'

// export function SaveLinesOrder (data = {}) {
//   return zzjg.request({
//     method: 'post',
//     url: '/SaveLinesOrder',
//     data
//   })
// }
export function B_other_company (data = {}) {
  return zzjg.request({
    method: 'post',
    url: '/B_other_company',
    data
  })
}
// export function codeData () {
//   return zzjg.request({
//     method: 'post',
//     url: '/codeData'
//   })
// }
// export function LinesData (data = {}) {
//   return zzjg.request({
//     method: 'post',
//     url: '/LinesData'
//   })
// }
// export function bsiteData (data = {}) {
//   return zzjg.request({
//     method: 'post',
//     url: '/bsiteData'
//   })
// }
// export function SaveBatchList (data = {}) {
//   return zzjg.request({
//     method: 'post',
//     url: '/SaveBatchList',
//     data,
//     iSFromData: true
//   })
// }
